import React, { useEffect, useState } from "react";
import FieldsRenderer from "../components/UI Helpers/InputFieldsRendererCommon/InputFieldsRendererComponent";
import { showAlertMessage } from "../components/MasterComponents/CommonFunctionalities";
import { validateForm } from "../components/UI Helpers/HelperFunctions/Helper"; 
import CommonCalls from "../components/CommonAPICalls/CommonCalls"; 
import Loader from "../components/UI Helpers/Simple Loading/Loader";
import Settings from "../components/CommonAPICalls/Settings";

const apiCall = new CommonCalls();

function DonationDetailsSeter() {
   const [saveBtn, setSaveBtn] = useState(false);
      const [loading, setLoading] = useState(true);
      const [priceData, setPriceData] = useState(null)
      const [mainApiData, setMainApiData] = useState(null)
      const [formInputData, setFormInputData] = useState("");
  
      const inputsFieldAr = [
        {
            name: 'category_type',
            id: 'category_type',
            label: 'Category Type',
            className: "col-lg-6",
            inputType: "dropdown",
            options: Settings.enumQurbaniCategories,
            required: true
        },
        {
            label: "Total Number of Portions",
            className: "col-lg-6",
            inputType: "number",
            name: "total_number_portions",
            id: "total_number_portions",
            required: false
        },
        {
            label: "Price of a single portion",
            className: "col-lg-6",
            inputType: "number",
            name: "single_portion_price",
            id: "single_portion_price",
            required: false
        }
    ];
    const filterByCategoryType = (data, type=1) => {
       
        return data.filter(item => item.category_type === parseInt(type));
    };

    const GetQurbaniPriceData = async ()=>{
        const response = await apiCall.getQurbaniPrice();
        if (response?.status === 200) {
            setLoading(false);
            const defaultData = filterByCategoryType(response?.data,1)[0]
            setMainApiData(response?.data)
            setFormInputData(
            defaultData
        )
      
        setPriceData(defaultData?.donation_qurbani_id)
            return response;
        } else {
            setLoading(false);
            showAlertMessage("Could not Load, Please Reload the Page", "fail");
            return;
        }
    }

      useEffect(()=>{
        setLoading(true)
        GetQurbaniPriceData()
      },[])

      useEffect(()=>{
        
        if(formInputData?.category_type)
        {

        setLoading(true)
        const defaultData =  filterByCategoryType(mainApiData,formInputData?.category_type)[0]
            setFormInputData(
           defaultData
        )
         setPriceData(defaultData?.donation_qurbani_id)
        setTimeout(()=>{
            setLoading(false)

        },1000)
        }
      },[formInputData?.category_type])
  
     const updateUserData = async () => {
    setSaveBtn(true);

    let validationResponse = validateForm(inputsFieldAr, formInputData);
    if (!validationResponse) {
        setSaveBtn(false);
        return;
    }

    const parsedData = Object.fromEntries(
        Object.entries(formInputData).map(([key, value]) => [key, parseInt(value) || 0])
    );

    setFormInputData(parsedData);

    const response = await apiCall.updateQurbaniPrice(parsedData, priceData);

    if (response?.status === 202) {
        setSaveBtn(false);
        GetQurbaniPriceData()
        showAlertMessage(response?.message, "success");
        return response;
    } else {
        setSaveBtn(false);
        showAlertMessage(response?.message, "fail");
        return;
    }
};

      return (
          <>
               <div className="user-detail-view-container container-fluid ps-4 pe-4 py-4">
                 {
                    loading ?
                    <div className='mt-5'> <Loader /> </div>
                    :
                      <form
                          onSubmit={(e) => {
                              e.preventDefault();
                              setSaveBtn(true);
                              updateUserData();
                          }}
                      >
                          <div className="w-100 text-end ">
                              <button
                                  type="submit"
                                  className="connect-button w-fit p-3 py-2"
                                  disabled={saveBtn}
                              >
                                  <div>
                                      <span> Save </span>{" "}
                                      {saveBtn ? (
                                          <output
                                              className="spinner-border spinner-border-sm ms-1"
                                              aria-hidden="true"
                                          ></output>
                                      ) : (
                                          ""
                                      )}
                                  </div>
                              </button>
                          </div>
                         
                          <FieldsRenderer
                              fieldsArray={inputsFieldAr}
                              updateState={setFormInputData}
                              currentState={formInputData}
                          />
                      </form>

                 }
                  </div>
          </>
      );
}

export default DonationDetailsSeter